var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress-bar',{staticClass:"progress-level",attrs:{"text":"","value":_vm.levelProgress,"grej":_vm.uhm}})}
var staticRenderFns = []

export { render, staticRenderFns }